import { useState, useEffect } from "react";
export const useScrollYPosition = ()=>{
    const [scrollPosition, setScrollPosition] = useState(0);
    const handleScroll = ()=>{
        if (typeof window === 'undefined') return;
        const position = window.pageYOffset;
        setScrollPosition(position);
    };
    useEffect(()=>{
        if (typeof window === 'undefined') return;
        window.addEventListener('scroll', handleScroll);
        return ()=>{
            if (typeof window === 'undefined') return;
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return scrollPosition;
};

//# sourceMappingURL=useScrollPosition.js.map